module.exports.PageLinks = {
    about: "about-miles-and-barr",
    general_enquiry: "general-enquiry",
    news_insight: "news-and-insights",
    branch_finder: "branch-finder",
    area_cover: "area-guides",
    branch_contact: "contact-us",
    team_contact: "contact-us",
    teams: "about-miles-and-barr/meet-the-team",
    request_valuation: "request-valuation",
    privacy_policy: "https://ggfx-milesnbarr2.s3.eu-west-2.amazonaws.com/i/Lomond_Privacy_Policy_Aug2025_dbb5bcca14.pdf",
    terms_condition: "compliance",
    cookie_policy: "compliance",
    book_a_viewing: "book-a-viewing",
    book_a_valuation: "request-a-valuation/home-visit-valuation",
    send_to_friend: "send-to-friend",
    property_to_rent: "property/to-rent",
    property_for_sale: "property/for-sale",
    reviews: "about-miles-and-barr/customer-reviews",
    property_management: "landlords/property-management",
    financial_services: "financial-services",
    guides_resources: "guides-and-resources",
    contact_investment_centre: "contact-investment-centre",
    investment_centre: "investment-centre",
    careers: "careers",
    current_vacancies: "careers/current-vacancies",
    job_details: "careers/job-details",
    furnishing_solutions: "furnishing-solutions"

}